namespace TabAurous.Inventory {
    export namespace ProductRepairItemsService {
        export const baseUrl = 'Repair/ProductRepairItems';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<RepairItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Repair/ProductRepairItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ProductRepairItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
